<g clip-path="url(#clip0_4_28)">
    <path
        d="M21.4384 40.331C21.4384 42.6227 23.3134 44.4977 25.6051 44.4977C27.8968 44.4977 29.7718 42.6227 29.7718 40.331C29.7718 38.0394 27.8968 36.1644 25.6051 36.1644C23.3134 36.1644 21.4384 38.0394 21.4384 40.331ZM21.4384 11.1644C21.4384 13.456 23.3134 15.331 25.6051 15.331C27.8968 15.331 29.7718 13.456 29.7718 11.1644C29.7718 8.87269 27.8968 6.99769 25.6051 6.99769C23.3134 6.99769 21.4384 8.87269 21.4384 11.1644ZM21.4384 25.7477C21.4384 28.0394 23.3134 29.9144 25.6051 29.9144C27.8968 29.9144 29.7718 28.0394 29.7718 25.7477C29.7718 23.456 27.8968 21.581 25.6051 21.581C23.3134 21.581 21.4384 23.456 21.4384 25.7477Z"
    />
</g>
<defs>
    <clipPath id="clip0_4_28">
        <rect
            width="50"
            height="50"
            transform="matrix(0 -1 1 0 0.605087 50.7477)"
        />
    </clipPath>
</defs>
